import styled from 'styled-components';
import { colorsV2 } from '../../colors-v2';

export const Divider = styled.div`
  background: ${colorsV2.gray100};
  opacity: 0.5;
  width: 1px;
  height: 24px;
`;
